import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { LandingComponent } from './landing/landing.component';
import { SharedModule } from './shared';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { HttpConfig } from './shared/services/httpconfig.interceptor';
import { MaintenanceComponent } from './maintenance/maintenance.component';

const MODULES = [
  BrowserModule,
  BrowserAnimationsModule,
  SharedModule,
  BrowserModule,
  AppRoutingModule,
  RouterModule,
  HttpClientModule,
  ToastrModule.forRoot(),
  NgbModule
];

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    MaintenanceComponent
  ],
  imports: [
    ...MODULES,
    BrowserAnimationsModule
  ],
  providers: [
    {  provide: HTTP_INTERCEPTORS, useClass: HttpConfig, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
